
import { defineComponent, onMounted } from "vue";
import Wms from "../components/Wms.vue";
import { setPageHeader } from "@/core/helpers/toolbar";

export default defineComponent({
    components: {
        Wms
    },
    setup() {
        onMounted(() => {
            setPageHeader({
                title: "message.WMS",
                actionButton: null,
                breadCrumbs: [
                    { name: "message.HOME", link: "/dashboard" },
                    { name: "message.SYSTEM", link: "#" },
                    { name: "message.WMS" }
                ]
            });
        });
    }
});
